var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgInside(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 0C9.62665 0 7.30655 0.703776 5.33317 2.02235C3.35978 3.34092 1.82172 5.21508 0.913466 7.40779C0.00521635 9.6005 -0.232446 12.0133 0.230576 14.3411C0.693597 16.6688 1.83652 18.807 3.51475 20.4853C5.19298 22.1635 7.33117 23.3064 9.65893 23.7694C11.9867 24.2324 14.3995 23.9948 16.5922 23.0865C18.7849 22.1783 20.659 20.6402 21.9776 18.6668C23.2962 16.6934 24 14.3733 24 12C24 8.81738 22.7357 5.76513 20.4853 3.5147C18.2349 1.26427 15.1826 0 12 0ZM12 22.5C9.92332 22.5 7.89328 21.8841 6.16657 20.7304C4.43986 19.5766 3.09402 17.9368 2.2993 16.0182C1.50458 14.0996 1.29668 11.9883 1.70183 9.95153C2.10697 7.91474 3.10694 6.04383 4.57539 4.57539C6.04383 3.10694 7.91474 2.10692 9.95154 1.70178C11.9883 1.29663 14.0996 1.50453 16.0182 2.29925C17.9368 3.09397 19.5766 4.43981 20.7304 6.16652C21.8841 7.89324 22.5 9.92328 22.5 12C22.5 14.7847 21.3938 17.4554 19.4247 19.4246C17.4555 21.3937 14.7848 22.5 12 22.5Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.0001 15.75C14.0711 15.75 15.75 14.071 15.75 12C15.75 9.92892 14.0711 8.24999 12.0001 8.24999C9.92899 8.24999 8.25006 9.92892 8.25006 12C8.25006 14.071 9.92899 15.75 12.0001 15.75Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInside);
export default __webpack_public_path__ + "static/media/Inside.0e2d1743af90982de47f5c7b6c95e2ba.svg";
export { ForwardRef as ReactComponent };